import RatingPage from '@app-studio-web/ui/pages/RatingPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'moodScale'

const ANSWER_TEXTS = {
  '1': 'Almost not at all',
  '2': 'Slightly',
  '3': 'Moderately',
  '4': 'Quite',
  '5': 'Very strongly',
}

export default function MoodScalePage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && Object.keys(ANSWER_TEXTS).includes(value) ? value : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the rating value from the form
    const formData = new FormData(event.currentTarget)
    const rating = formData.get('rating') as string
    console.log('Selected Rating:', rating)
    if (!rating) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How strongly does your home affect your mood?',
      answer_key: rating,
      answer: ANSWER_TEXTS[rating as keyof typeof ANSWER_TEXTS],
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  return (
    <RatingPage
      heading={t('pages.onboarding.conditionalBudget.mood.heading')}
      leftText={t('pages.onboarding.conditionalBudget.mood.options.1')}
      rightText={t('pages.onboarding.conditionalBudget.mood.options.5')}
      onSubmit={handleSubmit}
      buttonBgColor="bg-white"
      headingSize="text-3xl"
      preselectedValue={preselectedValue}
    />
  )
}
